import { Box, Typography } from "@mui/material";
import { keyframes, styled } from "@mui/material/styles";

const globalMetricsMarquee = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
`;

export const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "0 16px",
  minHeight: "36px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  backgroundColor: theme.palette.primary.main,
}));

export const MarqueeViewport = styled(Box)({
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
});

export const MarqueeTrack = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$duration",
})<{ $duration: number }>(({ $duration }) => ({
  display: "flex",
  alignItems: "center",
  gap: "24px",
  width: "fit-content",
  willChange: "transform",
  animation: `${globalMetricsMarquee} ${$duration}s linear infinite`,
}));

export const MarqueeGroup = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "24px",
  flexShrink: 0,
});

export const TooltipSlot = styled(Box)({
  flexShrink: 0,
});

export const Item = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
}));

const baseTextStyles = {
  fontSize: "10px",
  lineHeight: "15px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
};

export const Label = styled(Typography)(({ theme }) => ({
  ...baseTextStyles,
  color: theme.palette.primary.contrastText,
  opacity: 0.8,
  fontWeight: 300,
}));

export const Value = styled(Typography)(({ theme }) => ({
  ...baseTextStyles,
  color: theme.palette.primary.contrastText,
  fontWeight: 700,
}));
export const Platforms = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));
